const ERROR_CODES = {
  DUPLICATE_ENTITY: "DUPLICATE_ENTITY",
  ENTITY_NOT_FOUND: "ENTITY_NOT_FOUND",
  ENTITIES_NOT_FOUND: "ENTITIES_NOT_FOUND",
  DATABASE_ERROR: "DATABASE_ERROR",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  VALIDATION_ERROR: "VALIDATION_ERROR",
  FOREIGN_KEY_VIOLATION: "FOREIGN_KEY_VIOLATION",
  FIELD_VALIDATION: "FIELD_VALIDATION",
  WRONG_CREDENTIALS: "WRONG_CREDENTIALS",
  APPLIED_APPLICATION: "APPLIED_APPLICATION",
  APPLICATION_ALREADY_APPLIED: "APPLICATION_ALREADY_APPLIED",
  NOT_ENOUGH_PRODUCTS: 'NOT_ENOUGH_PRODUCTS',
};

const ERROR_MESSAGES = {
  DUPLICATE_ENTITY: "Duplicación de datos.",
  ENTITY_NOT_FOUND: "No se encontró registro",
  ENTITIES_NOT_FOUND: "No se encontraron registros",
  DATABASE_ERROR: "Error interno 01, contacte soporte",
  INTERNAL_SERVER_ERROR: "Error interno 02, contacte soporte",
  VALIDATION_ERROR: "Datos proporcionados inválidos.",
  FOREIGN_KEY_VIOLATION: "Hay dependencia en otro registro",
  FIELD_VALIDATION: "Campos con datos inválidos",
  WRONG_CREDENTIALS: "Credenciales Incorrectas",
  APPLIED_APPLICATION: "Registro con aplicaciones hechas",
  APPLICATION_ALREADY_APPLIED: "Aplicación ya aplicada",
    NOT_ENOUGH_PRODUCTS: 'No hay suficientes productos',
};

export { ERROR_CODES, ERROR_MESSAGES };
